import React from 'react';
import { classNames } from '../dom';

import { Button } from './Button';
export interface CloseButtonProps {
  /**
   * Override the accessible label
   * @default Close
   */
  'aria-label'?: string;
  /** Pass down class(es) to the underlying button */
  className?: string;
  /** Callback when clicked */
  onClick?(): Promise<void> | void;
}

/*
  An icon with a close button.  This is a shortcut since it is used so frequently in places like dialogs, alerts, etc.
 */
export function CloseButton(props: CloseButtonProps) {
  const classNamesString = classNames('ps-button--close', props.className ? props.className : '');

  return (
    <Button
      aria-label={props['aria-label'] ?? 'Close'}
      className={classNamesString}
      variant="icon-only"
      icon="Close"
      onClick={props.onClick}
    />
  );
}
